module.exports = __webpack_public_path__ + "img/168.3e336b0b.jpg";